export default __webpack_public_path__ + "static/media/ic-pulling-plug.ec6a61cf.svg";